import { USER_REQUEST, USER_ERROR, USER_SUCCESS, USER_SELECT_LIST } from '../actions/user';
import { userInfo } from '../../utils/api';
import { AUTH_LOGOUT } from '../actions/auth';

const state = { status: '', profile: {}, error:'', version:1.10 };

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}, token) =>  {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST);
      userInfo({authToken: token.authToken})
        .then( (resp) => {
          commit(USER_SUCCESS, resp.data);
          resolve(resp);
        })
        .catch( (error) => {
          commit(USER_ERROR, error.response.data);
          // if resp is unauthorized, logout, to
          dispatch(AUTH_LOGOUT);
          reject(error);
        });
    });
  },

  [USER_SELECT_LIST]: ({commit, dispatch}, list) =>{
    commit(USER_SELECT_LIST, list);
  }
};

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.profile = Object.assign({}, resp);
  },
  [USER_ERROR]: (state, resp) => {
    state.status = 'error';
    state.error = Object.assign({}, resp);
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {};
  },
  [USER_SELECT_LIST]: (state, list) => {
    state.profile.currentList = Object.assign(state.profile.currentList, list);
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
